<mat-dialog-content>
    <div *ngIf="!enableSelfRegistrationCode">
        <h3 style="color:#a20000;">{{'Link Already Sent' | translate}}</h3>
        <div style="padding-top:15px;" translate>A link for accessing the New Family Registration page was already emailed to this address.</div>
        <div style="padding-top:15px;">{{'Do you want to have the link sent again?' | translate}}</div>
    </div>
    <div *ngIf="enableSelfRegistrationCode">
        <h3 style="color:#a20000;">{{'Code Already Sent' | translate}}</h3>
        <div style="padding-top:15px;" translate>A code for proceeding to the next step of New Family Registration page was already emailed to this address.</div>
        <div style="padding-top:15px;">{{'Would you like to have the code sent again?' | translate}}</div>
    </div>

</mat-dialog-content>
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <tyl-button image="save.png" label="Yes" (clickEvent)="modalInstanceYesClick()"></tyl-button>
        <tyl-button image="Cancel.png" label="No" (clickEvent)="modalInstanceCloseClick()"></tyl-button>
    </div>
</mat-dialog-actions>
